import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import { Toaster } from 'react-hot-toast';
import Dashboard from './pages/Dashboard';
import Packs from './pages/Packs';
import PackDetail from './pages/PackDetail';
import NewPack from './pages/NewPack';
import Cells from './pages/Cells';
import CellDetail from './pages/CellDetail';
import NewCell from './pages/NewCell';
import Customers from './pages/Customers';
import NewCustomer from './pages/NewCustomer';
import TestHistory from './pages/TestHistory';
import NewTest from './pages/NewTest';
import EditTest from './pages/EditTest';
import Import from './pages/Import';
import AuditLogs from './pages/AuditLogs';
import EditPack from './pages/EditPack';
import EditCell from './pages/EditCell';
import { useAuth } from '@clerk/clerk-react';
import { useEffect } from 'react';
import api from './lib/api';
import { ProtectedRoute } from './components/ProtectedRoute';
import PostHogUserIdentity from './components/PostHogUserIdentity';

function ClerkAuthHandler() {
  const { getToken } = useAuth();

  useEffect(() => {
    const interceptor = api.interceptors.request.use(async (config) => {
      try {
        const token = await getToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        console.error('Error getting Clerk token:', error);
      }
      return config;
    });

    return () => {
      api.interceptors.request.eject(interceptor);
    };
  }, [getToken]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(8px)',
            color: '#111827',
            padding: '16px',
            borderRadius: '16px',
            border: '1px solid rgba(243, 244, 246, 1)',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
            fontSize: '14px',
            fontWeight: '600',
            maxWidth: '450px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
          },
          success: {
            style: {
              borderLeft: '4px solid #10b981',
              background: 'rgba(255, 255, 255, 0.98)',
            },
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            style: {
              borderLeft: '4px solid #ef4444',
              background: 'rgba(255, 255, 255, 0.98)',
              borderRight: '1px solid rgba(239, 68, 68, 0.1)',
              borderTop: '1px solid rgba(239, 68, 68, 0.1)',
              borderBottom: '1px solid rgba(239, 68, 68, 0.1)',
            },
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      <ClerkAuthHandler />
      <PostHogUserIdentity />
      <Layout>
        <Routes>
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/packs" element={<ProtectedRoute><Packs /></ProtectedRoute>} />
          <Route path="/packs/new" element={<ProtectedRoute requiredRole="editor"><NewPack /></ProtectedRoute>} />
          <Route path="/packs/:id" element={<ProtectedRoute><PackDetail /></ProtectedRoute>} />
          <Route path="/packs/:id/edit" element={<ProtectedRoute requiredRole="editor"><EditPack /></ProtectedRoute>} />
          <Route path="/cells" element={<ProtectedRoute><Cells /></ProtectedRoute>} />
          <Route path="/cells/new" element={<ProtectedRoute requiredRole="editor"><NewCell /></ProtectedRoute>} />
          <Route path="/cells/:id" element={<ProtectedRoute><CellDetail /></ProtectedRoute>} />
          <Route path="/cells/:id/edit" element={<ProtectedRoute requiredRole="editor"><EditCell /></ProtectedRoute>} />
          <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
          <Route path="/customers/new" element={<ProtectedRoute><NewCustomer /></ProtectedRoute>} />
          <Route path="/tests" element={<ProtectedRoute><TestHistory /></ProtectedRoute>} />
          <Route path="/tests/new" element={<ProtectedRoute><NewTest /></ProtectedRoute>} />
          <Route path="/tests/:packId/:testId/edit" element={<ProtectedRoute requiredRole="editor"><EditTest /></ProtectedRoute>} />
          <Route path="/audit" element={<ProtectedRoute requiredRole="editor"><AuditLogs /></ProtectedRoute>} />
          <Route path="/import" element={<ProtectedRoute requiredRole="editor"><Import /></ProtectedRoute>} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;


